import { createAsyncThunk } from '@reduxjs/toolkit';
import { postCreateAbsence } from 'store/records/services/postCreateAbsence.service';

export const createAbsenceForTimeframe = createAsyncThunk(
  'records/createAbsenceForTimeframe',
  async ({
    absenceType,
    fromDate,
    toDate,
    projectId,
    resourceId,
    description,
  }) => {
    const response = await postCreateAbsence({
      projectId,
      absenceType,
      fromDate,
      toDate,
      resourceId,
      description,
    });

    return response;
  }
);
